var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.formGroupClass
  }, [_c('validation-provider', {
    attrs: {
      "name": _vm.label.toLowerCase(),
      "rules": _vm.rules
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(validationContext) {
        return [_c('label', [_vm._v(" " + _vm._s(_vm.label) + " "), _vm.field && _vm.field.required ? _c('span', {
          staticClass: "required-indc"
        }, [_vm._v(" * ")]) : _vm._e()]), _vm.field && _vm.field.field_name ? _c('date-picker', {
          attrs: {
            "aria-describedby": "input-feedback",
            "input-class": _vm.apiErrors && _vm.apiErrors[_vm.field.field_name] || validationContext.errors[0] ? 'invalid-date-picker mx-input ' : 'mx-input',
            "placeholder": _vm.placeholder,
            "disabled": _vm.field && _vm.field.readOnly,
            "format": _vm.dateFormat,
            "value-type": "format",
            "state": _vm.getValidationState(validationContext)
          },
          scopedSlots: _vm._u([{
            key: "input",
            fn: function fn(_ref) {
              var props = _ref.props,
                  events = _ref.events;
              return [_c('input', _vm._g(_vm._b({
                attrs: {
                  "size": "10",
                  "maxlength": "10",
                  "onkeyup": "this.value=this.value.replace(/^(\\d\\d)(\\d)$/g,'$1/$2').replace(/^(\\d\\d\\/\\d\\d)(\\d+)$/g,'$1/$2').replace(/[^\\d\\/]/g,'')"
                }
              }, 'input', props, false), events))];
            }
          }], null, true),
          model: {
            value: _vm.form[_vm.field.field_name],
            callback: function callback($$v) {
              _vm.$set(_vm.form, _vm.field.field_name, $$v);
            },
            expression: "form[field.field_name]"
          }
        }) : _vm._e(), _vm.apiErrors && _vm.apiErrors[_vm.field.field_name] || validationContext.errors[0] ? _c('error-text', {
          attrs: {
            "errors": _vm.apiErrors ? _vm.apiErrors : validationContext.errors ? validationContext.errors : '',
            "field": _vm.field.field_name
          }
        }) : _vm._e()];
      }
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }